import React, { Component } from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import completedTickImg from '../../images/icons/tick_icon_white.png';
import bottomPointsIcon from '../../images/icons/points_icon.png';
import HmEventRegistry from '../../model/HmEventRegistry';

class TopicComponent extends LoggedInPage {
	
  constructor(props) {
  	super(props);  
  	this.onTopicStart = this.onTopicStart.bind(this);  	
  	 this.handleMouseOver = this.handleMouseOver.bind(this);
     this.handleMouseOut = this.handleMouseOut.bind(this);

  	 this.state = {
  		gifAnimSrc:'',
  		gifSrc: '',
  		imgSrc: '',
  		boxColor: ''
  	 };  	 
  }
  
  componentDidMount(){	
		  //console.log("selectedGrade::"+this.props.selectedGradeLabel);
		  let boxDefaultColor = "#8D6E63";
		  let boxDefaultImg = "box_default.png";
		  
			let boxcolor = boxDefaultColor;
			let boxImgSrc = require("../../images/animations/"+boxDefaultImg);
			let boxgifsrc = require("../../images/animations/"+boxDefaultImg);
			

			//console.log("lalala: topic::",this.props.topic);

			if(this.props.topic.staticImgPath && this.props.topic.staticImgPath != ""){
				boxImgSrc = this.props.topic.staticImgPath;
			}
			if(this.props.topic.animatedImgPath && this.props.topic.animatedImgPath != ""){
				boxgifsrc = this.props.topic.animatedImgPath;
			}
			if(this.props.topic.colourCode && this.props.topic.colourCode != ""){
				boxcolor = this.props.topic.colourCode;
			}
			/*console.log(this.props.topic.staticImgPath);
			console.log(this.props.topic.animatedImgPath);
			console.log(this.props.topic.colourCode);*/
			/*if (boxColorObj.hasOwnProperty(folder)) {
			     if(boxColorObj[folder].hasOwnProperty(filename)) {
			    	 boxcolor = boxColorObj[folder][filename];
			    	 boxImgSrc = require("../../images/animations/"+folder+"/"+filename+".gif");			    	 
			    	 if(this.props.topic.status === "COMPLETED"){
			    		 boxgifsrc = require("../../images/animations/"+folder+"/"+filename+".gif");
			    	 }else{
			    		 boxgifsrc = require("../../images/animations/"+folder+"/"+filename+"_anim.gif");
			    	 }
			    }
			}*/
			
		
			this.setState({
			      imgSrc: boxImgSrc,
			      gifAnimSrc:boxgifsrc,
			  		gifSrc: boxImgSrc,
			  		boxColor: boxcolor
			    });
			
			
			HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
  }
  onTopicStart(){
	// console.log(this.props.topic.subTopicMap);	
	 this.props.callbackParent(this.props.topic,this.props.dataIndex,this.state.boxColor);
  }

  handleMouseOver() {
    this.setState({
      imgSrc: this.state.gifAnimSrc
    });    
  }

  handleMouseOut() {
    this.setState({
    	 imgSrc: this.state.gifSrc
    });
    
  }

  getUserTopicPoints(){
  	if(this.props.topic && this.props.topic.userTopicPoints){
  		return !isNaN(this.props.topic.userTopicPoints) ? this.props.topic.userTopicPoints : 0;
  	}

  	return 0;
  }

  getTopicPoints(){
  	 if(this.props.topic && this.props.topic.topicPoints){
  	 	return !isNaN(this.props.topic.topicPoints) ? this.props.topic.topicPoints : 0;
  	 }

  	 return 0;
  }
  getLesssonsActionLabel(){
  	    switch (this.props.topic.status) {
	      case "COMPLETED":   return this.rb("lesson.watched");
	      case "IN_PROGRESS": return this.rb("home.resume");
	      default:      return this.rb("home.start");
	    }
  }
  getTestsActionLabel(){
	  	switch (this.props.topic.status) {
	      case "COMPLETED":   return this.rb("home.revise");
          case "IN_PROGRESS": return this.rb("home.resume");
          default:      return this.rb("home.start");
	    }
  }
  getTopicBottomSection(){
  	 let me = this;

	  if(this.props.lessonOnlyMode == true){
		  return(
					<div className="card-body card-bottom text-center lessononlytopic">	
			 		    <div className="card-link tileLink showcursor" onClick={this.onTopicStart} data-ga={"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topic.topicName+" - "+this.getLesssonsActionLabel()}>		    		    	
				    		    <h5>
				    		      {(() => {
				    		      	if(me.props.topic.topicLocked === true){
				    		      		return this.rb("topic.locked");
				    		      	}

				    		      	switch (me.props.topic.status) {
				    		          case "COMPLETED":   return this.rb("lesson.watched");
				    		          case "IN_PROGRESS": return this.rb("home.resume");
				    		          default:      return this.rb("home.start");
				    		        }
				    		      })()}
				    		    </h5>
			   		     </div>
			   		</div>
				);
	  }else{
		  return(
					<div className="card-body card-bottom">			      		    
			   		    <span className="card-link user-points">
			   		    	<img className="bottomPointsIcon" src={bottomPointsIcon} />
			   		    	<span className="user-points">{this.getUserTopicPoints()}</span>
			   		    	 / 
			   		    	<span className="points">{this.getTopicPoints()}</span>
			   		    </span>
			 		    <div className="card-link float-right tileLink showcursor" onClick={this.onTopicStart}  data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topic.topicName+" - "+this.getTestsActionLabel()}>		    		    	
				    		    <h5>
				    		      {(() => {
				    		      	if(me.props.topic.topicLocked === true){
				    		      		return this.rb("topic.locked");
				    		      	}

				    		        switch (me.props.topic.status) {
				    		          case "COMPLETED":   return this.rb("home.revise");
				    		          case "IN_PROGRESS": return this.rb("home.resume");
				    		          default:      return this.rb("home.start");
				    		        }
				    		      })()}
				    		    </h5>
			   		     </div>
			   		</div>
				);
	  }
	
  }
  
  render() {
	  
    return (  
    		
    		 			<div className={"card "+this.props.selectedGradeLabel}>
			      		  <div className="card-img-top topic text-center" style={{backgroundColor: this.state.boxColor}} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
			      		  		<img className={"bgimg animgif " + ((this.props.topic.status === "COMPLETED" && this.props.lessonOnlyMode == false) ? 'opacityInGif' : '')} src={this.state.imgSrc} />
			      		  		{(() => {
				    		        if(this.props.topic.status === "COMPLETED") {
				    		        	if(this.props.lessonOnlyMode == false){
				    		        	 return <img className="topiccompletedIcon" src={completedTickImg} />;				    		       
				    		        	}
				    		        }
				    		      })()}
			      		  		
			      		  		
			      		  </div>
			      			  <div className="card-img-overlay">
			      			    <div className="card-title">{this.props.topic.topicName}</div>		    			    
			      			  </div>
			      			  {/*marked questions hidden -- kamaraj*/}
			      			  {/*<div className="heading-elements">
			      			  	
			      			  	<nav className="navbar fixed-top navbar-expand-md">
			    	    	            <ul className="navbar-nav mr-auto">			    	             
			    	    	                <li className="nav-item dropdown">
			    	    	                    <div className="float-right" data-toggle="dropdown"><i className="material-icons">more_vert</i></div>
			    	    	                    <div className="clearfix"></div>
			    	    	                    <div className="dropdown-menu">
			    	    	                        <a className="dropdown-item" href="#"><i className="material-icons">star</i> {this.rb("home.markedquestions")}</a>
			    	    	                        <div className="dropdown-divider"></div>
			    	    	                        <a className="dropdown-item" href="#"><i className="material-icons">reply</i> {this.rb("home.share")}</a>
			    	    	                    </div>
			    	    	                </li>
			    	    	            </ul>
			      	            </nav>
			      	
			                  </div>*/}
			      			  <div className="card-body descBody">	    		   
				      		    <p className="card-text">{this.props.topic.topicDescription}</p>
				      		  </div>    
				      		  
			      		 {this.getTopicBottomSection()}
			      		  
			    		</div>
    );
  }
}

export default TopicComponent;



// WEBPACK FOOTER //
// ./src/views/plp/TopicComponent.js